<!--
/**
 * @copyright   OnlyOneProd © 2025
 * @authors     Jonathan COULLET <contact@onlyoneprod.com>
 * @link        https://onlyoneprod.com
 * @notice      All information contained herein is,
 *              and remains the property of OnlyOneProd and its suppliers,
 *              Any dissemination of this information or reproduction
 *              of this material is strictly forbidden unless prior
 *              written permission is obtained from OnlyOneProd.
 */
-->

<template>
    <div id="page" class="snapable">
        <SectionHero>
            <h1>Révélez le potentiel unique de votre marque pour créer des expériences
                <strong>innovantes</strong>, <strong>cohérentes</strong> et <strong>captivantes</strong>.
            </h1>
            <div class="actions">
                <a @click="clickHandler('services')" title="Découvrez nos services">
                    <CommonButton size="large" :outlined="true">Dites m'en plus</CommonButton>
                </a>
                <a @click="clickHandler('contact')" title="Contactez-nous">
                    <CommonButton size="large" icon="next">Je me lance</CommonButton>
                </a>
            </div>
        </SectionHero>
        <SectionServices />
        <SectionValeurs />
        <SectionMethode />
        <CommonSpacer />
        <SectionPartenaires />
        <SectionContact />
        <CommonSpacer />
        <SectionFooter :isHome="true" />
    </div>
</template>

<script setup lang="ts">
import SectionContact from "@/components/modules/SectionContact.vue";
import SectionFooter from "@/components/modules/SectionFooter.vue";
import SectionHero from "@/components/modules/SectionHero.vue";
import SectionMethode from "@/components/modules/SectionMethode.vue";
import SectionPartenaires from "@/components/modules/SectionPartenaires.vue";
import SectionServices from "@/components/modules/SectionServices.vue";
import SectionValeurs from "@/components/modules/SectionValeurs.vue";

import CommonButton from "@/components/common/CommonButton.vue";
import CommonSpacer from "@/components/common/CommonSpacer.vue";

import { trackButtonClick } from "@/helpers/analytics.helper";
import { scrollToSection } from "@/helpers/scroll.helper";

const clickHandler = (name: string) => {
    trackButtonClick(`home-hero-${name}`);
    scrollToSection(name);
}
</script>

<style lang="sass">
</style>
